import React, { useState } from 'react';
import './HeroSection.css';
import Modal from './Modal';

const HeroSection = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleButtonClick = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleMoreInfoClick = () => {
    window.open('https://www.getmyorderportal.com', '_blank', 'noopener,noreferrer');
  };

  return (
    <>
      <div className="hero-section">
        {/* Logo */}
        <div className="logo">
          <img src="/myorderportal.png" alt="Order Portal - Restaurant Online Ordering Solutions" className="logo-image" />
        </div>

        <div className="hero-content">
          {/* Desktop: Left Section - Illustration */}
          <div className="illustration-section">
            <img src="/hero.svg" alt="Restaurant online ordering assessment illustration - Increase your restaurant orders" className="hero-illustration" />
          </div>

          {/* Content Section */}
          <div className="content-section">
            <h1 className="main-headline">Increase Your Restaurant's Online Orders</h1>
            <h2 className="sub-headline">Take our free assessment and reach your growth potential</h2>
            
            {/* Mobile: Illustration between headings and description */}
            <div className="mobile-illustration">
              <img src="/hero.svg" alt="Restaurant online ordering assessment illustration - Increase your restaurant orders" className="hero-illustration" />
            </div>
            
            <p className="description">
              This free assessment has been designed to show restaurant owners their blind spots and provide actionable insight on how to increase online orders for all restaurant types.
            </p>

            <ul className="feature-list">
              <li className="feature-item">
                <div className="checkmark">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" fill="#1E3A8A"/>
                  </svg>
                </div>
                <span>It takes just 5 minutes</span>
              </li>
              <li className="feature-item">
                <div className="checkmark">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" fill="#1E3A8A"/>
                  </svg>
                </div>
                <span>It's completely free</span>
              </li>
              <li className="feature-item">
                <div className="checkmark">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" fill="#1E3A8A"/>
                  </svg>
                </div>
                <span>Receive customized results instantly</span>
              </li>
            </ul>

            <div className="button-container">
              <button className="cta-button" onClick={handleButtonClick}>
                Take the Assessment
              </button>
              
              <button className="secondary-button" onClick={handleMoreInfoClick}>
                More Info
              </button>
            </div>
          </div>
        </div>
      </div>
      
      <Modal isOpen={isModalOpen} onClose={handleCloseModal} />
    </>
  );
};

export default HeroSection;
